/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { Button } from '@mui/material';

import { Namespaces } from '../../i18n';
import { createLinkExpiredStyles } from './LinkExpired.styles';

type LinkExpiredProps = {
  subTitle?: string;
};

export const LinkExpired = memo<LinkExpiredProps>(props => {
  const { t } = useTranslation(Namespaces.Common);
  const classes = createLinkExpiredStyles();
  const { subTitle } = props;
  return (
    <div className={classes.root}>
      <h3 className={classes.title}>{t('link_expired.link_expired')}</h3>
      {subTitle && <h5 className={classes.subTitle}>{subTitle}</h5>}
      <div className={classes.linkContainer}>
        <NavLink to={'/'} className={classes.link}>
          <Button type="submit" color="primary" variant="contained" size="large">
            {t('link_expired.button')}
          </Button>
        </NavLink>
      </div>
    </div>
  );
});
